<style lang="less">
    .discern .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.6rem .2rem .2rem;
        z-index: 9;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            background:#FFFDE4;
            padding:.2rem .4rem 0;
            >div{
                width:100%;
                height:100%;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
                .choice_img{
                    width:100%;
                    height:auto;
                    display: block;
                }
            }
        }
    }
    .discern .play_trast_con{
        width:100%;
        height:auto;
        min-height: 4.5rem;
        padding:0.6rem 0.8rem 1.2rem;
        background:url("../assets/images/blackboard-phone.png") no-repeat;
        background-size:100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .discern_title{
            width:100%;
            text-align: center;
            font-size: .48rem;
            color:#fff;
            margin-bottom:.3rem;
        }
        .discern_text{
            width:100%;
            text-align: center;
            font-size: .36rem;
            color:#fff;
        }
    }
    .discern .tra_bottom{
        width:100%;
        margin:.5rem auto 0;
        padding-bottom: .2rem;
        .answer_list{
            width:100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .answer_item{
                width:1.5rem;
                height:auto;
                margin-right:.1rem;
                .opts_item{
                    width:100%;
                    height:auto;
                    display: block;
                }
                .opts_btn{
                    width:.8rem;
                    height:auto;
                    display: block;
                    position: relative;
                    bottom: .2rem;
                    left:50%;
                    transform: translateX(-50%);
                    z-index: 11;
                }
            }
            .answer_item:last-child{
                margin-right:0;
            }
        }
        .btnHover{
            margin:0 auto;
        }
    }
    .discern .result_con{
        position: relative;
        .result{
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 11;
            background: rgba(0,0,0,.5);
            display: flex;
            align-items: center;
            justify-content: center;

            p{
                font-size: .7rem;
                color: #fff;
                margin-bottom: .2rem;
            }
        }
    }
</style>
<template>
    <div class="discern" @touchmove.prevent>
        <div class="pd">
            <div class="art_text_con"><!-- 蓝底 padding -->
                <img src="../assets/images/up-article-phone.png" alt="">
                <div class="art_inner"><!-- 黄底 padding -->
                    <div>
                        <div class="play_trast_con" :style="choice_img?'padding: 0.6rem 0.6rem .8rem':''">
                            <div v-if="!choice_img">
                                <p class="discern_title">辨圖</p>
                                <p class="discern_text">
                                下邊哪一幅圖畫較適合用作今天文章的內容？</p>
                            </div>
                            <div class="result_con" v-else>
                                <img class="choice_img" :src="imgBaseUrl + choice_img" alt="">
                                <div v-if="status!='wait'" class="result">
                                    <div v-if="status=='right'" class="res_right">
                                        <p>答對了！</p>
                                    </div>
                                    <div v-else-if="status=='wrong'" class="res_wrong">
                                        <p>答錯了</p>
                                        <div class="btnHover" @click="again">再玩一次</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tra_bottom">
                        <div class="answer_list">
                            <div class="answer_item" v-for="(item,index) in gameData.opts" :key="index" @click="choice(item,index)">
                                <img class="opts_item" :src="imgBaseUrl + item.text" alt="">
                                <!-- <img class="opts_btn" :src="data.btsImgs[index].btn" alt=""> -->
                                <img class="opts_btn" :src="index===choice_idx?require('../assets/images/choose1-pc.png'):require('../assets/images/nochoose-pc.png')" alt="">
                            </div>
                        </div>
                        <div class="btnHover" @click="submit">確認</div>
                    </div>
                </div>
                <img src="../assets/images/down-article-phone.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        gameData:{
            type:Object,
            default:{},
        },
        game_id:{
            type:String,
            default:'1',
        },
        date:{
            type:String,
            default:'',
        },
        push_id:{
            type:String,
            default:'',
        }
    },
    data(){
        return {
            choice_img:'',
            choice_idx:'',
            status:'wait',
            data:{
                question:'',
                desc:'',
                // btsImgs:[
                //     {
                //         btn:require('../assets/images/choose1-pc.png'),
                //     },
                //     {
                //         btn:require('../assets/images/choose2-pc.png'),
                //     },
                //     {
                //         btn:require('../assets/images/choose3-pc.png'),
                //     },
                // ],
            }
        }
    },
    mounted(){
        console.log(this.date)
    },
    methods:{
        choice(item,index){
            console.log(item);
            this.choice_img = item.text;
            this.choice_idx = index;
        },
        again(){
            this.choice_img='';
            this.choice_idx='';
            this.status='wait';
        },
        submit(){
            let vm = this;
            this.$http.get(this.baseUrl+"/Game/distinguishPush/GaID/"+this.game_id+"/SrtSet/"+ this.gameData.opts[this.choice_idx].id +"/SrtTime/"+ 5 + '/pushdate/'+ this.date  +"/sn/"+ Math.random()).then(res=>{
                console.log(res)
                if(res.data == 'pass'){
                    vm.status='right';
                    setTimeout(()=>{
                        vm.$emit('next');
                    },3000)
                }else{
                    vm.status='wrong';
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/game-discern.vue